import { shade } from 'polished'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const ButtonCreateMobile = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: #776cf1;
  border-radius: 16px;
  padding: 10px 20px;
  text-decoration: none;
  height: auto;
  flex-grow: initial;
  align-items: center;
  display: flex;
  max-height: 34px;
  transition-duration: 0.2s;

  &:hover {
    background-color: ${shade(0.2, '#776cf1')};
    color: white;
  }

  svg {
    margin-right: 12px;
  }

  @media ${queries.less.xll} {
    position: fixed;
    top: calc(100vh - 60px);
    right: 10px;
    z-index: 5;
    font-size: 0;
    border-radius: 50%;
    min-height: 50px;
    min-width: 50px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin: 0;
      padding: 0;
    }
  }
`

export const BtnCreateMobile = styled.button`
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: #776cf1;
  border-radius: 16px;
  padding: 10px 20px;
  text-decoration: none;
  height: auto;
  flex-grow: initial;
  align-items: center;
  display: flex;
  max-height: 34px;
  transition-duration: 0.2s;
  border: none;

  &:hover {
    background-color: ${shade(0.2, '#776cf1')};
    color: white;
  }

  svg {
    margin-right: 12px;
  }

  @media ${queries.less.xll} {
    position: fixed;
    top: calc(100vh - 60px);
    right: 10px;
    z-index: 5;
    font-size: 0;
    border-radius: 50%;
    min-height: 50px;
    min-width: 50px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      margin: 0;
      padding: 0;
    }
  }
`
